import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const getDataList = async (type) => {
    if (!type) {
        throw new Error('getDataList argument is missing');
    }

    let path = type.charAt(0) === '/' ? type : `/${type}`;

    const url = process.env.REACT_APP_CMS_API_PATH + path;
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;

    return await axios({
        url,
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
